module.exports = __webpack_public_path__ + "img/img6.418f8c82.svg";